/* Silk Scarfs - page collection : curseur avant/revers, coloris, tailles, ajout au panier, tri, « Show more ». */
(function () {
  'use strict';

  /* (04/10) plusieurs sections appellent ce fichier : une seule copie pose les ecouteurs (sinon clic, clavier
     et defilement etaient doubles) */
  if (window.__ssCollectionJs) return;
  window.__ssCollectionJs = true;

  document.documentElement.classList.add('ss-js');

  var ICONS = {
    head: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="11" cy="10" r="4.6"/><path d="M6.6 8.6c2.9-1.3 5.9-1.3 8.8 0M15.4 8.6l3.1-1.9M15.4 8.6l2.7 2M5 21c.9-3.2 3.2-5 6-5s5.1 1.8 6 5"/></svg>',
    body: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><circle cx="12" cy="6.8" r="3.4"/><path d="M5 21c.8-3.9 3.5-6.2 7-6.2s6.2 2.3 7 6.2M8.7 12.3c2.1 1.5 4.5 1.5 6.6 0M13.7 13.2l1.1 4.6"/></svg>',
    knot: '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M12 12C9.9 8.7 5.9 7.6 4.7 9.4c-1.1 1.8.6 4.3 7.3 2.6ZM12 12c2.1-3.3 6.1-4.4 7.3-2.6 1.1 1.8-.6 4.3-7.3 2.6Z"/><path d="m11.1 12.9-1.9 5.3M12.9 12.9l1.9 5.3"/></svg>'
  };

  function text(el, value) { if (el) el.textContent = value == null ? '' : value; }

  /* Pouces -> centimetres, meme arrondi que le snippet Liquid ss-size (cm = pouces × 2,54, entier).
     sizeLabel(« 27.5 × 27.5 in ») = « 27.5 in (70 cm) » ; cmShort = « 70 cm » (« 5 × 85 cm » si les
     deux cotes different). Une valeur deja en cm est rendue telle quelle. */
  function sizeParts(n) {
    var s = String(n || '');
    var nums = s.match(/\d+(?:\.\d+)?/g) || [];
    if (!nums.length || /cm/i.test(s)) return null;
    var cms = nums.map(function (x) { return String(Math.round(parseFloat(x) * 2.54)); });
    var same = nums.every(function (x) { return x === nums[0]; });
    return { inch: same ? nums[0] : nums.join(' × '), cm: same ? cms[0] : cms.join(' × ') };
  }
  function sizeLabel(n) { var p = sizeParts(n); return p ? p.inch + ' in (' + p.cm + ' cm)' : String(n || ''); }
  function cmShort(n) { var p = sizeParts(n); return p ? p.cm + ' cm' : ''; }
  /* forme complete pour l'infobulle, comme le Liquid : « 51 × 51 in (130 × 130 cm) » */
  function sizeFull(n) {
    var s = String(n || '');
    var nums = s.match(/\d+(?:\.\d+)?/g) || [];
    if (!nums.length || /cm/i.test(s)) return s;
    return nums.join(' × ') + ' in (' + nums.map(function (x) { return String(Math.round(parseFloat(x) * 2.54)); }).join(' × ') + ' cm)';
  }

  /* ---------- Ajout au panier (tiroir Ella) ---------- */
  function addToCart(id, button, errorEl) {
    if (!window.fetch || !id) return;
    var body = { items: [{ id: Number(id), quantity: 1 }] };
    var cart = document.querySelector('cart-drawer');
    if (window.SSShell && window.SSShell.sectionId && window.SSShell.sectionId()) {
      body.sections = window.SSShell.sectionId();
      body.sections_url = window.location.pathname;
    }
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    if (errorEl) errorEl.textContent = '';
    if (button) { button.setAttribute('aria-busy', 'true'); }
    fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        if (!res.ok || res.json.status) {
          if (errorEl) errorEl.textContent = res.json.description || res.json.message || 'Something went wrong. Please try again.';
          return;
        }
        var json = res.json;
        if (json.items && json.items[0] && json.id == null) json.id = json.items[0].id;
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ss-collection', productVariantId: id, cartData: json });
        }
        if (window.SSShell && window.SSShell.added) {
          window.SSShell.added(json);
        } else if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(json);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function () {
        if (errorEl) errorEl.textContent = 'Something went wrong. Please try again.';
      })
      .finally(function () { if (button) button.removeAttribute('aria-busy'); });
  }

  /* ---------- Carte ---------- */
  function initCard(card) {
    if (!card || card.__ssCard) return;
    card.__ssCard = true;
    var viewHost = card.closest ? card.closest('[data-ss-view]') : null;
    if (viewHost) viewSizes(card, viewHost.getAttribute('data-ss-view'));

    var dataEl = card.querySelector('[data-ss-card-data]');
    var data = { ways: [] };
    try { data = JSON.parse(dataEl.textContent); } catch (e) { /* carte non interactive */ }
    var ways = data.ways || [];
    var isDemo = data.demo === true;

    var media = card.querySelector('[data-ss-media]');
    var front = card.querySelector('.ss-pc__img--front');
    var back = card.querySelector('.ss-pc__img--rev');
    var nameEl = card.querySelector('[data-ss-link]');
    var priceEl = card.querySelector('[data-ss-price]');
    var wasEl = card.querySelector('[data-ss-was]');
    var wasVal = card.querySelector('[data-ss-was-v]');
    var pctEl = card.querySelector('[data-ss-pct]');
    var saleEl = card.querySelector('[data-ss-sale]');
    var pricesEl = card.querySelector('[data-ss-prices]');
    var fiberEl = card.querySelector('[data-ss-fiber]');
    var badgeEl = card.querySelector('[data-ss-badge]');
    var usesLabel = card.querySelector('[data-ss-use-label]');
    var usesIcons = card.querySelector('[data-ss-use-icons]');
    var sizesBox = card.querySelector('[data-ss-sizes]');
    var addBtn = card.querySelector('[data-ss-add]');
    var errorEl = card.querySelector('[data-ss-error]');
    /* le coloris 0 est le produit de la carte : son lien garde le contexte de collection
       (/collections/x/products/y), que les donnees JSON (p.url) ne connaissent pas */
    var ownHref = nameEl && nameEl.tagName === 'A' ? nameEl.getAttribute('href') : '';
    if (ways[0] && ownHref) ways[0].u = ownHref;

    var wayIndex = 0;
    var sizeIndex = -1;

    /* recto / verso : la classe double la regle :has() pour les navigateurs qui l'ignorent */
    var sideInputs = card.querySelectorAll('[data-ss-side]');
    if (media && sideInputs.length) {
      var syncSide = function () {
        var rev = card.querySelector('.ss-pc__side-in--rev');
        if (rev && rev.checked) { media.classList.add('is-rev'); } else { media.classList.remove('is-rev'); }
      };
      for (var si = 0; si < sideInputs.length; si++) sideInputs[si].addEventListener('change', syncSide);
      syncSide();
    }

    function currentWay() { return ways[wayIndex] || null; }

    /* prix barre : suit la taille ou le coloris choisi, et disparait quand il n'y en a pas */
    function setWas(val) {
      if (!wasEl) return;
      if (val) { text(wasVal, val); wasEl.hidden = false; } else { wasEl.hidden = true; }
      // le prix de vente passe en couleur promo seulement quand un prix barre l'accompagne
      if (pricesEl) { if (val) { pricesEl.classList.add('is-sale'); } else { pricesEl.classList.remove('is-sale'); } }
      // 25/10 : label « Sale » et pourcentage (rendus seulement sur les produits concernes) suivent le prix barre
      if (saleEl) saleEl.hidden = !val;
      if (pctEl) {
        var nowN = moneyNum(priceEl ? priceEl.textContent : ''), wasN = moneyNum(val);
        var pc = (val && wasN > nowN && nowN > 0) ? Math.floor((wasN - nowN) * 100 / wasN) : 0;
        if (pc > 0) { pctEl.textContent = '-' + pc + '%'; pctEl.hidden = false; } else { pctEl.hidden = true; }
      }
    }
    function moneyNum(s) { var m = String(s || '').match(/\d[\d,]*(?:\.\d+)?/g); return m ? parseFloat(m[m.length - 1].replace(/,/g, '')) : 0; }

    function soldOut() {
      if (!addBtn) return;
      text(addBtn.querySelector('[data-ss-add-text]'), addBtn.getAttribute('data-soldout') || 'Sold out');
      addBtn.classList.remove('is-ready');
      addBtn.setAttribute('aria-disabled', 'true');
    }

    function applySize(index, fromClick) {
      var way = currentWay();
      if (!way || !way.sz || !way.sz[index]) return;
      var size = way.sz[index];
      if (size.a === false) return;
      sizeIndex = index;
      if (sizesBox) {
        Array.prototype.forEach.call(sizesBox.querySelectorAll('[data-ss-size]'), function (el) {
          var on = Number(el.getAttribute('data-ss-size')) === index;
          el.classList.toggle('is-on', on);
          if (on) { el.setAttribute('aria-current', 'true'); } else { el.removeAttribute('aria-current'); }
        });
      }
      if (priceEl && size.p) text(priceEl, size.p);
      setWas(size.c || '');
      if (addBtn) {
        var label = addBtn.getAttribute('data-add') || '';
        var full = sizeLabel(size.n || size.l || '');
        /* taille unique : elle est deja ecrite sur la pastille, le bouton reste sur une ligne */
        var single = way.sz.length === 1;
        text(addBtn.querySelector('[data-ss-add-text]'), full && !single ? label + ', ' + full : label);
        addBtn.classList.add('is-ready');
        addBtn.removeAttribute('aria-disabled');
        if (way.u) addBtn.setAttribute('href', size.id ? way.u + '?variant=' + size.id : way.u);
      }
      if (fromClick && errorEl) errorEl.textContent = '';
    }

    function renderSizes() {
      var way = currentWay();
      if (!sizesBox || !way) return;
      var list = way.sz || [];
      sizesBox.innerHTML = '';
      if (list.length === 1 && !list[0].l) {
        if (list[0].n) {
          var one = document.createElement('span');
          one.className = 'ss-pc__one';
          one.innerHTML = '<span class="ss-pc__one-mark" aria-hidden="true"></span>';
          one.appendChild(document.createTextNode(sizeLabel(list[0].n)));
          sizesBox.appendChild(one);
        }
        if (list[0].a === false) { sizeIndex = -1; soldOut(); return; }
        sizeIndex = 0;
        if (addBtn && list[0]) {
          var lab = addBtn.getAttribute('data-add') || '';
          text(addBtn.querySelector('[data-ss-add-text]'), list[0].n ? lab + ', ' + sizeLabel(list[0].n) : lab);
          addBtn.classList.add('is-ready');
          addBtn.removeAttribute('aria-disabled');
        }
        return;
      }
      list.forEach(function (size, i) {
        if (i > 2) return; /* trois tailles au plus sur la carte, le reste est sur la fiche */
        var el;
        if (way.u) {
          el = document.createElement('a');
          el.setAttribute('href', size.id ? way.u + '?variant=' + size.id : way.u);
        } else {
          el = document.createElement('button');
          el.setAttribute('type', 'button');
        }
        el.className = 'ss-pc__size' + (size.a === false ? ' is-off' : '');
        el.setAttribute('data-ss-size', String(i));
        el.setAttribute('data-label', sizeFull(size.n || size.l || ''));
        el.setAttribute('title', sizeFull(size.n || size.l || ''));
        /* taille unique a deux cotes differents (twilly) : pastille large, mesure entiere */
        var parts = sizeParts(size.n || size.l);
        var wide = list.length === 1 && !!parts && parts.inch.indexOf('×') > -1;
        if (wide) el.className += ' ss-pc__size--wide';
        var inEl = document.createElement('span');
        inEl.className = 'ss-pc__size-in';
        inEl.textContent = wide ? parts.inch + ' in' : size.l;
        el.appendChild(inEl);
        var cmTxt = cmShort(size.n || size.l);
        if (cmTxt && (list.length > 1 || wide)) {
          var cmEl = document.createElement('span');
          cmEl.className = 'ss-pc__size-cm';
          cmEl.setAttribute('aria-hidden', 'true');
          cmEl.textContent = cmTxt;
          el.appendChild(cmEl);
        }
        if (size.a === false) el.setAttribute('aria-label', (size.n || size.l) + ' - ' + (addBtn ? addBtn.getAttribute('data-soldout') || 'Sold out' : 'Sold out'));
        sizesBox.appendChild(el);
      });
      /* taille unique : le centimetre a droite de la pastille */
      var p0 = list.length === 1 ? sizeParts(list[0].n || list[0].l) : null;
      if (p0 && p0.inch.indexOf('×') < 0) {
        var side = document.createElement('span');
        side.className = 'ss-pc__size-side';
        side.setAttribute('aria-hidden', 'true');
        side.textContent = cmShort(list[0].n || list[0].l);
        sizesBox.appendChild(side);
      }
      if (list.length > 3) {
        var more = document.createElement('span');
        more.className = 'ss-pc__size-more';
        more.setAttribute('aria-hidden', 'true');
        more.textContent = '+' + (list.length - 3);
        sizesBox.appendChild(more);
      }
      var unit = card.getAttribute('data-unit');
      if (unit) {
        var u = document.createElement('span');
        u.className = 'ss-pc__unit';
        u.textContent = unit;
        sizesBox.appendChild(u);
      }
      sizeIndex = -1;
      if (addBtn) {
        text(addBtn.querySelector('[data-ss-add-text]'), addBtn.getAttribute('data-choose') || '');
        addBtn.classList.remove('is-ready');
        addBtn.removeAttribute('aria-disabled');
        if (way.u) addBtn.setAttribute('href', way.u);
      }
      /* une seule taille : rien a choisir, elle est prise d'office (ou dite epuisee) */
      if (list.length === 1) { if (list[0].a !== false) applySize(0, false); else soldOut(); }
    }

    function markWays(index) {
      Array.prototype.forEach.call(card.querySelectorAll('[data-ss-way]'), function (el) {
        var on = Number(el.getAttribute('data-ss-way')) === index;
        el.classList.toggle('is-active', on);
        if (el.tagName === 'BUTTON') el.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function applyWay(index, keepVisual) {
      var way = ways[index];
      if (!way) return;
      wayIndex = index;
      if (keepVisual) {
        markWays(index);
        var only = way.sz && way.sz.length === 1 ? way.sz[0] : null;
        if (only && only.a !== false) { applySize(0, false); } else if (only) { soldOut(); }
        return;
      }
      var swapImg = function (img, src, set, alt) {
        if (!img || !src) return;
        if (set) { img.setAttribute('srcset', set); } else { img.removeAttribute('srcset'); }
        img.setAttribute('src', src);
        if (alt != null) img.setAttribute('alt', alt);
      };
      var sets = way.set || [];
      swapImg(front, way.img && way.img[0], sets[0], way.t || '');
      /* 2e image dans un <picture> (survol ordinateur) : on change la SOURCE, pas l'<img> de repli,
         sinon le mobile telechargerait la photo au premier changement de coloris */
      var backPic = back && back.parentNode && back.parentNode.tagName === 'PICTURE' ? back.parentNode : null;
      if (backPic) {
        var backSrc = backPic.querySelector('source');
        if (backSrc && sets[1]) backSrc.setAttribute('srcset', sets[1]);
      } else {
        swapImg(back, way.img && way.img[1], sets[1], null);
      }
      swapImg(card.querySelector('[data-ss-thumb="0"] img'), way.img && way.img[0], sets[0], '');
      swapImg(card.querySelector('[data-ss-thumb="1"] img'), way.img && way.img[1], sets[1], '');
      if (nameEl) {
        text(nameEl, way.t);
        if (way.u && nameEl.tagName === 'A') nameEl.setAttribute('href', way.u);
      }
      if (priceEl) text(priceEl, way.p);
      setWas(way.c || '');
      if (fiberEl) { text(fiberEl, way.f); fiberEl.hidden = !way.f; }
      if (badgeEl) { text(badgeEl, way.b); badgeEl.hidden = !way.b; }
      if (usesLabel) text(usesLabel, String(way.us || '').split(', ').join(' \u00b7 '));
      if (usesIcons) {
        var keys = String(way.ul || '');
        var html = '';
        if (keys.indexOf('head') > -1) html += ICONS.head;
        if (keys.indexOf('body') > -1) html += ICONS.body;
        if (keys.indexOf('knot') > -1) html += ICONS.knot;
        usesIcons.innerHTML = html;
      }
      markWays(index);
      renderSizes();
    }

    /* clics dans la carte */
    card.addEventListener('click', function (e) {
      if (!ways.length) return;
      var way = e.target.closest('[data-ss-way]');
      if (way && ways.length > 1) {
        e.preventDefault();
        applyWay(Number(way.getAttribute('data-ss-way')));
        return;
      }
      var size = e.target.closest('[data-ss-size]');
      if (size) {
        if (size.classList.contains('is-off')) return;
        e.preventDefault();
        applySize(Number(size.getAttribute('data-ss-size')), true);
        return;
      }
      var add = e.target.closest('[data-ss-add]');
      if (add && add.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      if (add) {
        var cur = currentWay();
        var chosen = cur && cur.sz ? cur.sz[sizeIndex] : null;
        if (isDemo || !chosen || !chosen.id) {
          if (sizeIndex < 0 && sizesBox && sizesBox.querySelector('[data-ss-size]')) {
            e.preventDefault();
            sizesBox.classList.add('is-asking');
            var first = sizesBox.querySelector('[data-ss-size]:not(.is-off)');
            if (first && first.focus) first.focus();
            window.setTimeout(function () { sizesBox.classList.remove('is-asking'); }, 1200);
          }
          return;
        }
        e.preventDefault();
        if (add.getAttribute('aria-busy') === 'true') return;
        addToCart(chosen.id, add, errorEl);
      }
    });

    if (ways.length) applyWay(0, true);
  }

  /* ---------- Tri ---------- */
  function initSort(form) {
    if (!form || form.__ssSort) return;
    form.__ssSort = true;
    var select = form.querySelector('select[name="sort_by"]');
    if (!select) return;
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Voir plus ---------- */
  function initMore(section) {
    var button = section.querySelector('[data-ss-more]');
    if (!button || button.__ssMore) return;
    button.__ssMore = true;
    button.addEventListener('click', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var url = button.getAttribute('href');
      if (!url || button.getAttribute('aria-busy') === 'true') return;
      var sectionId = section.getAttribute('data-ss-section');
      var fetchUrl = url;
      if (sectionId) fetchUrl += (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectionId);
      button.setAttribute('aria-busy', 'true');
      fetch(fetchUrl)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = section.querySelector('[data-ss-grid]');
          var newGrid = doc.querySelector('[data-ss-grid]');
          if (!grid || !newGrid) { window.location.href = url; return; }
          if (grid && newGrid) {
            var added = [];
            Array.prototype.forEach.call(newGrid.children, function (li) {
              var node = document.importNode(li, true);
              grid.appendChild(node);
              added.push(node);
            });
            added.forEach(initCard);
            var lk = added.length ? added[0].querySelector('.ss-pc__link') : null;
            if (lk && lk.focus) {
              lk.setAttribute('tabindex', '-1');
              lk.focus();
              lk.addEventListener('blur', function () { lk.removeAttribute('tabindex'); }, { once: true });
            }
          }
          var showing = section.querySelector('[data-ss-showing]');
          var newShowing = doc.querySelector('[data-ss-showing]');
          if (showing && newShowing) showing.textContent = newShowing.textContent;
          var next = doc.querySelector('[data-ss-more]');
          if (next && next.getAttribute('href')) {
            button.setAttribute('href', next.getAttribute('href'));
          } else {
            button.remove();
          }
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { button.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- Barre collante : on mesure l'en-tete plutot que de coder sa hauteur ----------
     Le CSS a un repli (--ss-stick-fb) ; ici on ecrit la valeur juste, y compris quand l'en-tete
     mobile remplace celui du bureau ou quand la barre d'annonce disparait au defilement. */
  function stickTop() {
    var total = 0;
    var els = document.querySelectorAll('.shopify-section-group-header-group');
    for (var i = 0; i < els.length; i++) {
      var cs = window.getComputedStyle(els[i]);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') continue;
      var h = els[i].getBoundingClientRect().height;
      if (h <= 0) continue;
      var top = parseFloat(cs.top);
      total += h + (isNaN(top) ? 0 : top);
    }
    if (total <= 0) return 0;
    return Math.max(0, Math.floor(total) - 1);
  }

  var stickAt = 0;
  var stickVal = -1;
  function syncStick() {
    var v = stickTop();
    if (v <= 0) return;
    document.documentElement.style.setProperty('--ss-stick-top', v + 'px');
    stickVal = v;
  }
  function queueStick() {
    var now = +new Date();
    if (now - stickAt < 200) return;
    stickAt = now;
    syncStick();
  }

  /* ---------- Menus deroulants ----------
     Ce sont de vrais <details> : sans JavaScript ils s'ouvrent quand meme, et les entrees restent
     des liens. Le JS ne fait qu'ajouter les manieres : un seul ouvert, fermeture au clic dehors et
     a Echap, et un panneau qui bascule a droite quand il deborderait de l'ecran. */
  function closeDrops(except) {
    var open = document.querySelectorAll('[data-ss-drop][open]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) open[i].removeAttribute('open');
    }
  }

  function placePanel(drop) {
    drop.classList.remove('ss-fdrop--right');
    var panel = drop.querySelector('.ss-fdrop__panel');
    if (!panel) return;
    if (window.getComputedStyle(panel).position === 'fixed') return; /* feuille mobile : rien a caler */
    var r = panel.getBoundingClientRect();
    if (r.right > document.documentElement.clientWidth - 8) drop.classList.add('ss-fdrop--right');
  }

  function initDrops(section) {
    var drops = section.querySelectorAll('[data-ss-drop]');
    for (var i = 0; i < drops.length; i++) {
      (function (drop) {
        if (drop.__ssDrop) return;
        drop.__ssDrop = true;
        drop.addEventListener('toggle', function () {
          if (!drop.hasAttribute('open')) return;
          closeDrops(drop);
          placePanel(drop);
        });
        var closers = drop.querySelectorAll('[data-ss-drop-close]');
        for (var k = 0; k < closers.length; k++) {
          closers[k].addEventListener('click', function () { drop.removeAttribute('open'); });
        }
      })(drops[i]);
    }
  }

  var dropsWired = false;
  function wireDropsOnce() {
    if (dropsWired) return;
    dropsWired = true;
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('[data-ss-drop]')) return;
      closeDrops(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) closeDrops(null);
    });
    window.addEventListener('resize', function () { stickAt = 0; queueStick(); });
    window.addEventListener('load', function () { stickAt = 0; queueStick(); });
    window.addEventListener('scroll', queueStick, { passive: true });
    window.setTimeout(function () { stickAt = 0; queueStick(); }, 300);
    window.setTimeout(function () { stickAt = 0; queueStick(); }, 1200);
  }

  /* ---------- Ce qui est coche, lu dans l'URL ----------
     Shopify ne remplit `collection.filters` que si des filtres boutique sont configures. Tant que
     ce n'est pas fait, le rendu serveur croit que rien n'est coche et laisse « All … » allume
     meme quand on vient de choisir « 100% silk ». On relit donc la requete : c'est juste dans les
     deux cas, et ca restera d'accord avec Shopify le jour ou les filtres seront actives. */
  function queryMap() {
    var out = {};
    /* filtres « tag » : /collections/<handle>/<tag>+<tag> (adresse native Shopify) */
    var pm = window.location.pathname.match(/\/collections\/[^\/]+\/([^\/]+)\/?$/);
    if (pm) {
      try { out.tag = decodeURIComponent(pm[1]).split('+'); } catch (e) {}
    }
    var q = window.location.search.replace(/^\?/, '');
    if (!q) return out;
    var parts = q.split('&');
    for (var i = 0; i < parts.length; i++) {
      if (!parts[i]) continue;
      var eq = parts[i].indexOf('=');
      var k = eq < 0 ? parts[i] : parts[i].slice(0, eq);
      var v = eq < 0 ? '' : parts[i].slice(eq + 1);
      try {
        k = decodeURIComponent(k.replace(/\+/g, ' '));
        v = decodeURIComponent(v.replace(/\+/g, ' '));
      } catch (e) { continue; }
      if (!out[k]) out[k] = [];
      out[k].push(v);
    }
    return out;
  }

  function setOn(el, on) {
    if (on) { el.classList.add('is-active'); el.setAttribute('aria-current', 'true'); }
    else { el.classList.remove('is-active'); el.removeAttribute('aria-current'); }
  }

  function itemLabel(el) {
    var l = el.querySelector('.ss-fitem__label');
    return l ? l.textContent.trim() : '';
  }

  /* Un groupe : ses entrees normales se cochent sur l'URL, son entree « tous » ne s'allume que si
     aucune des autres n'est cochee. C'est la seule regle juste quand deux groupes partagent le
     meme parametre (les matieres et les usages sont tous deux des tags produit). */
  function markGroup(box, q) {
    var items = box.querySelectorAll('.ss-fitem');
    var alls = [];
    var n = 0;
    var last = '';
    for (var i = 0; i < items.length; i++) {
      var el = items[i];
      if (el.hasAttribute('data-ss-fall')) { alls.push(el); continue; }
      var p = el.getAttribute('data-ss-fp');
      var v = el.getAttribute('data-ss-fv');
      var on = !!(p && v && q[p] && q[p].indexOf(v) > -1);
      setOn(el, on);
      if (on) { n++; last = itemLabel(el); }
    }
    for (var k = 0; k < alls.length; k++) setOn(alls[k], n === 0);
    return { n: n, label: last };
  }

  function syncFilters(section) {
    var q = queryMap();
    var boxes = section.querySelectorAll('[data-ss-group]');
    var counts = {};
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var res = markGroup(box, q);
      counts[box.getAttribute('data-ss-group')] = res.n;
      var drop = box.closest ? box.closest('[data-ss-drop]') : null;
      if (!drop || drop.getAttribute('data-ss-all-label') === null) continue;
      var txt = drop.querySelector('.ss-fbtn__txt');
      if (txt) {
        var label = drop.getAttribute('data-ss-all-label') || '';
        if (res.n === 1) label = res.label;
        else if (res.n > 1) label = (drop.getAttribute('data-ss-multi') || '[N]').replace('[N]', res.n);
        txt.textContent = label;
      }
      if (res.n > 0) { drop.classList.add('is-set'); } else { drop.classList.remove('is-set'); }
    }

    var total = 0;
    for (var key in counts) {
      if (Object.prototype.hasOwnProperty.call(counts, key)) total += counts[key];
    }
    var bar = section.querySelector('[data-ss-fbar]');
    if (bar) {
      if (total > 0) { bar.classList.add('is-filtered'); } else { bar.classList.remove('is-filtered'); }
    }
    var allBtn = section.querySelector('[data-ss-drop-all]');
    if (allBtn) {
      var base = allBtn.getAttribute('data-ss-filter-label') || '';
      var t2 = allBtn.querySelector('.ss-fbtn__txt');
      if (t2) t2.textContent = total > 0 ? base + ' (' + total + ')' : base;
      if (total > 0) { allBtn.classList.add('is-set'); } else { allBtn.classList.remove('is-set'); }
    }
  }

  /* ---------- Tri en feuille (telephone) : meme adresse que le <select>, filtres conserves ---------- */
  function initSortLinks(section) {
    Array.prototype.forEach.call(section.querySelectorAll('[data-ss-sort-to]'), function (a) {
      if (a.__ssSortTo) return;
      a.__ssSortTo = true;
      a.addEventListener('click', function (e) {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
        e.preventDefault();
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', a.getAttribute('data-ss-sort-to'));
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ---------- 1 ou 2 colonnes (telephone) : le choix est retenu par le navigateur ---------- */
  /* la derniere valeur de `sizes` (telephone) suit le nombre de colonnes : 100vw en 1 colonne, 50vw en 2,
     sinon le navigateur garde l'image choisie pour une demi-largeur et la photo est floue en grand */
  function viewSizes(root, v) {
    var vw = Math.round(100 / Number(v)) + 'vw';
    Array.prototype.forEach.call(root.querySelectorAll('img.ss-pc__img[sizes]'), function (img) {
      var s = img.getAttribute('sizes');
      var n = s.replace(/\d+vw\s*$/, vw);
      if (n !== s) img.setAttribute('sizes', n);
    });
  }

  function initViews(section) {
    var box = section.querySelector('[data-ss-views]');
    if (!box || box.__ssViews) return;
    box.__ssViews = true;
    var btns = box.querySelectorAll('[data-ss-view]');
    function apply(v) {
      if (v !== '1' && v !== '2') return;
      section.style.setProperty('--ss-cols-m', v);
      section.setAttribute('data-ss-view', v);
      viewSizes(section, v);
      Array.prototype.forEach.call(btns, function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-ss-view') === v ? 'true' : 'false'); });
    }
    var saved = null;
    try { saved = window.localStorage.getItem('ss-coll-view'); } catch (e) { /* stockage indisponible */ }
    if (saved) apply(saved);
    Array.prototype.forEach.call(btns, function (b) {
      b.addEventListener('click', function () {
        var v = b.getAttribute('data-ss-view');
        apply(v);
        try { window.localStorage.setItem('ss-coll-view', v); } catch (e) { /* stockage indisponible */ }
      });
    });
  }

  function init(section) {
    if (!section) return;
    Array.prototype.forEach.call(section.querySelectorAll('[data-ss-card]'), initCard);
    Array.prototype.forEach.call(section.querySelectorAll('[data-ss-sort]'), initSort);
    initSortLinks(section);
    initViews(section);
    initMore(section);
    initDrops(section);
    syncFilters(section);
  }

  /* les filtres natifs (ss-facets.js) rechargent la section : ils rebranchent cartes, tri et menus par ici */
  window.SSColl = { init: init };

  function boot() {
    wireDropsOnce();
    syncStick();
    Array.prototype.forEach.call(document.querySelectorAll('[data-ss-coll]'), init);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:block:select', function (e) {
    var d = e.target && e.target.closest ? e.target.closest('[data-ss-drop]') : null;
    if (!d) return;
    closeDrops(d);
    d.setAttribute('open', '');
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var d = e.target && e.target.closest ? e.target.closest('[data-ss-drop]') : null;
    if (d) d.removeAttribute('open');
  });
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-ss-coll]');
    if (root) init(root);
  });
})();
